<template>
    <div class="news">
          <div class="left">
              <img src="../assets/ycb/al.png" alt="">
          </div>
             <div class="right">
              <div class="text">
                   <p>{{$t('home').news.text0[0]}}</p>
                  <p>{{$t('home').news.text0[1]}}</p>
                  <div class="btn" @click="gotoPro">
                      {{$t('btn')}}
                  </div>
              </div>
         </div>
    </div>
</template>

<script>
    export default {
        name: "news",
        data(){
            return{

            }
        },
        methods:{
            gotoPro(){
                const link ='pro.html'
                window.open(link,'_self')
            }
        }
    }
</script>

<style lang="scss" scoped>
.news{
    width:60%;
    margin: 60px auto;
    animation-duration: 3s;
    display: flex;
    flex-direction: row;
    .left{
        width:50%;
        overflow: hidden;
        img{
            width:100%;
            display: block;
            object-fit: cover;
            transition: all 3s ;
            cursor: pointer;
        }
        &:hover{
                img{
                    transform: scale(1.05);
            }
        }
    }
    .right{
        width:50%;
        background-color: #263346;
        .text{
            width:70%;
            margin: 10% auto;
            height:80%;
            background-color: #F8F8F8;
            padding-top: 30px;
            p{
                width:80%;
                margin: 30px auto;
            }
            p:nth-child(1){
                color:#4A4A4A;
                font-size: 35px;
                text-transform: uppercase;
                font-family: "DINEngschriftStd";
                padding: 30px 0;
                position: relative;
                &::after{
                    content:'';
                    display: inline-block;
                    width:51px;
                    height:1px;
                    background:rgba(210,210,210,1);
                    position: absolute;
                    bottom:0;
                left:0;
                }
            }
            p:nth-child(2){
                font-family: "itbook";
                line-height: 40px;
            }
            .btn{
                width:50%;
                height:40px;
                border:1px solid rgba(145,145,145,1);
                border-radius:20px;
                transition: all 600ms;
                line-height: 40px;
                text-transform: uppercase;
                font-family: "it";
                text-align: center;
                margin: 30px 10%;
                cursor: pointer;
                &:hover{
                    background-color: #1C8B48;
                    color:white;
                }
            }
        }
    }
    @media screen and (max-width: 1440px){
        width:90%;
    }
    @media screen and (max-width: 1000px){
     flex-direction: column;
        margin: 30px auto;
        margin-bottom: 0;
        .left,.right{
            width:100%;
        }
        .right{
            margin-top: 20px;
            .text{
                width:90%;
                padding-top: 0;
                padding-bottom: 20px;
                p:nth-child(1){
                    font-size: 30px;
                    padding: 15px 0;
                }
                p:nth-child(2){
                    margin: 15px auto;
                    line-height: 30px;
                    font-size: 14px;
                }
            }
        }
    }
}
</style>
